import { ReactNode, useCallback } from 'react';

import { cx } from '@libs/classnames';
import { IconButton } from '@ui/components/IconButton';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { ArrowHeadIcon } from '@ui/icons/ArrowHeadIcon';

import { usePromoHeaderToggle } from '@features/club/pages/ClubListPage/usePromoHeaderToggle';
import { ClubsListPromoHeader } from '@features/club/ui/ClubsListPromoHeader/ClubsListPromoHeader';

import styles from './ClubListPage.module.css';
import { BookmarkButton } from '@ui/components/BookmarkButton';
import { CreateIcon } from '@ui/icons/CreateIcon';
import { BookmarkButtonBar } from '@ui/components/BookmarkButtonBar';

export type Props = {
  navigation: ReactNode;
  promotedClubs: ReactNode;
  allClubsList: ReactNode;
  modals: ReactNode;
  onClubCreate?: () => void;
};

export function ClubListPage({
  navigation,
  promotedClubs,
  allClubsList,
  modals,
  onClubCreate,
}: Props) {
  const isMobile = useMediaQuery() === 'mobile';
  const {isCollapsed, onCollapsedToggle} = usePromoHeaderToggle();
  const toggle = useCallback(() => {
    onCollapsedToggle(!isCollapsed);
  }, [isCollapsed, onCollapsedToggle]);

  return (
    <>
      <div className={cx(styles.homeHeader, {[styles.collapsed]: isCollapsed})}>
        {navigation}

        <div className={styles.promoContent}>
          <div className={styles.collapsible}>
            {isMobile && <div className={styles.separator}/>}

            <div className={styles.promoHeaderWrapper}>
              <ClubsListPromoHeader/>
            </div>

            {promotedClubs}
          </div>
          <IconButton className={styles.collapseButton} onClick={toggle}>
            <ArrowHeadIcon/>
          </IconButton>
        </div>
      </div>

      <div className={cx(styles.allClubsList, {[styles.collapsed]: isCollapsed})}>
        {allClubsList}
      </div>

      {modals}

      {onClubCreate && (
        <BookmarkButtonBar className={styles.buttonBar}>
          <BookmarkButton icon={<CreateIcon/>} label="Создать клуб" onClick={onClubCreate}/>
        </BookmarkButtonBar>
      )}
    </>
  );
}
